(function () {
  'use strict';

  var CONFIG = {
    webhookUrl: 'https://script.google.com/macros/s/AKfycbyII4pcjpOwaRDbUilyv0PuoE5BZQuqk8VsvSz3dV9ETV5rSDeVkKhJfJ8Jzz8tvbFz1Q/exec', 
    token: '05370087f168a4a7a7db6842db046f2a962f7e065f5942d598bd5e631c43c85b',                
    leadPrefix: 'ML',
    storageKey: '_fpd_attr',
    cookieDays: 90,
    pendingKey: '_fpd_pending_lead',
    pendingTtlMs: 30 * 60 * 1000,
    successPattern: /thank-you|contact_posted=true/i,
    excludeFields: ['body', 'message', 'date_of_birth', 'page_url'],
    maxLen: 200
  };

  var GOOGLE_IDS = ['gclid', 'gbraid', 'wbraid'];
  var CLICK_IDS = GOOGLE_IDS.concat(['fbclid']);
  var UTMS = ['source', 'medium', 'campaign', 'term', 'content'];
  var TOUCH_KEYS = UTMS.concat(['landing_page', 'referrer', 'timestamp']);
  var FIELD_KEYS = ['lead_id', 'gclid', 'gbraid', 'wbraid', 'gclid_ts', 'fbclid', 'fbc', 'fbp', 'ga_client_id']
    .concat(TOUCH_KEYS.map(function (k) { return 'lt_' + k; }))
    .concat(TOUCH_KEYS.map(function (k) { return 'ft_' + k; }));
  var ALIAS = { page_title: 'service', preferred_day: 'preferred_date', marketing: 'marketing_opt_in', policy: 'policy_agreed' };
  var SEARCH = /(^|\.)(google|bing|yahoo|duckduckgo|baidu|yandex|ecosia|naver)\./i;
  var SOCIAL = /(^|\.)(facebook|instagram|tiktok|linkedin|pinterest|youtube|reddit|threads)\./i;
  var IGNORE_REF = /(^|\.)(shopify\.com|shop\.app|hcaptcha\.com|paypal\.com|stripe\.com)$/i;

  /* ---------- helpers ---------- */
  function now() { return Date.now(); }
  function trunc(v) { v = v == null ? '' : String(v); return v.length > CONFIG.maxLen ? v.slice(0, CONFIG.maxLen) : v; }
  function norm(k) { return String(k).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }
  function parse(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function hostOf(url) { try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }
  function pageUrl() { return trunc(location.origin + location.pathname); }

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (parts[i].slice(0, eq) === name) {
        try { return decodeURIComponent(parts[i].slice(eq + 1)); } catch (e) { return ''; }
      }
    }
    return '';
  }
  function setCookie(name, value, days) {
    var exp = new Date(now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp +
      '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function store(type) { try { return window[type]; } catch (e) { return null; } }
  function sGet(type, k) { try { return store(type).getItem(k); } catch (e) { return null; } }
  function sSet(type, k, v) { try { store(type).setItem(k, v); } catch (e) {} }
  function sDel(type, k) { try { store(type).removeItem(k); } catch (e) {} }

  /* ---------- attribution state: cookie + localStorage + sessionStorage ---------- */
  function readState() {
    var best = null;
    [getCookie(CONFIG.storageKey), sGet('localStorage', CONFIG.storageKey), sGet('sessionStorage', CONFIG.storageKey)]
      .forEach(function (raw) {
        var s = parse(raw);
        if (s && s.v === 1 && (!best || (s.updated || 0) > (best.updated || 0))) best = s;
      });
    return best || { v: 1, updated: 0, ids: {}, ft: null, lt: null };
  }
  function writeState(s) {
    s.updated = now();
    var raw = JSON.stringify(s);
    setCookie(CONFIG.storageKey, raw, CONFIG.cookieDays);
    sSet('localStorage', CONFIG.storageKey, raw);
    sSet('sessionStorage', CONFIG.storageKey, raw);
  }

  function capture() {
    var s = readState(), t = now(), changed = false, p;
    try { p = new URLSearchParams(location.search); } catch (e) { return s; }
    s.ids = s.ids || {};

    // Click IDs: always keep the latest click. A new Google click clears
    // stale Google IDs so an old gclid never beats a fresh gbraid/wbraid.
    var googleNow = GOOGLE_IDS.filter(function (k) { return p.get(k); });
    if (googleNow.length) {
      GOOGLE_IDS.forEach(function (k) { delete s.ids[k]; delete s.ids[k + '_ts']; });
    }
    CLICK_IDS.forEach(function (k) {
      var v = p.get(k);
      if (v) { s.ids[k] = trunc(v); s.ids[k + '_ts'] = t; changed = true; }
    });

    // Touch: UTMs > Google click > external referrer > fbclid. Direct and
    // internal visits never overwrite the last touch.
    var ref = document.referrer || '', refHost = hostOf(ref);
    var self = location.hostname.replace(/^www\./, '');
    var external = refHost && refHost !== self && !IGNORE_REF.test(refHost);
    var touch = null, m;
    if (UTMS.some(function (k) { return p.get('utm_' + k); })) {
      touch = {};
      UTMS.forEach(function (k) { touch[k] = trunc(p.get('utm_' + k) || ''); });
    } else if (googleNow.length) {
      touch = { source: 'google', medium: 'cpc' };
    } else if (external) {
      if ((m = refHost.match(SEARCH))) touch = { source: m[2].toLowerCase(), medium: 'organic' };
      else if ((m = refHost.match(SOCIAL))) touch = { source: m[2].toLowerCase(), medium: 'social' };
      else touch = { source: refHost, medium: 'referral' };
    } else if (p.get('fbclid')) {
      touch = { source: 'facebook', medium: 'social' };
    }

    if (touch) {
      UTMS.forEach(function (k) { touch[k] = touch[k] || ''; });
      touch.landing_page = pageUrl();
      touch.referrer = trunc(ref.split('?')[0]);
      touch.timestamp = new Date(t).toISOString();
      s.lt = touch;
      if (!s.ft) s.ft = touch;
      changed = true;
    } else if (!s.ft) {
      s.ft = { source: '(direct)', medium: '(none)', campaign: '', term: '', content: '',
        landing_page: pageUrl(), referrer: '', timestamp: new Date(t).toISOString() };
      changed = true;
    }
    if (changed) writeState(s);
    return s;
  }

  /* ---------- values for the hidden fields ---------- */
  function fromGclCookie() { // _gcl_aw = GCL.<unix seconds>.<gclid>, set by Google's conversion linker
    var parts = getCookie('_gcl_aw').split('.');
    return parts.length >= 3 ? { id: parts.slice(2).join('.'), ts: parseInt(parts[1], 10) * 1000 } : null;
  }
  function attribution(s) {
    var ids = s.ids || {}, out = {};
    var hasGoogle = ids.gclid || ids.gbraid || ids.wbraid;
    var gcl = hasGoogle ? null : fromGclCookie();
    out.gclid = ids.gclid || (gcl ? gcl.id : '');
    out.gbraid = ids.gbraid || '';
    out.wbraid = ids.wbraid || '';
    var gts = ids.gclid_ts || ids.gbraid_ts || ids.wbraid_ts || (gcl ? gcl.ts : 0);
    out.gclid_ts = gts ? new Date(gts).toISOString() : '';
    out.fbclid = ids.fbclid || '';
    out.fbc = getCookie('_fbc') || (ids.fbclid ? 'fb.1.' + (ids.fbclid_ts || now()) + '.' + ids.fbclid : '');
    out.fbp = getCookie('_fbp');
    var ga = getCookie('_ga').split('.'); // GA1.1.<random>.<timestamp>
    out.ga_client_id = ga.length >= 4 ? ga.slice(-2).join('.') : '';
    var ft = s.ft || {}, lt = s.lt || s.ft || {};
    TOUCH_KEYS.forEach(function (k) { out['ft_' + k] = ft[k] || ''; out['lt_' + k] = lt[k] || ''; });
    return out;
  }

  /* ---------- forms ---------- */
  function isContactForm(f) {
    return !!(f && f.tagName === 'FORM' && f.querySelector('input[name="form_type"][value="contact"]'));
  }
  function field(form, name) { return form.querySelector('input[name="' + name + '"]'); }
  function addHidden(form, name) {
    if (field(form, name)) return;
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    form.appendChild(i);
  }
  function ensureFields(form) {
    FIELD_KEYS.forEach(function (k) { addHidden(form, 'fpd_' + k); });
    addHidden(form, 'contact[Lead ID]'); // shows in Shopify's email, matches the sheet row
  }
  function fillFields(form, s) {
    var a = attribution(s);
    Object.keys(a).forEach(function (k) {
      var el = field(form, 'fpd_' + k);
      if (el) el.value = a[k];
    });
  }
  function newLeadId() {
    var d = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; }, r = '';
    try {
      var a = new Uint32Array(2);
      window.crypto.getRandomValues(a);
      r = a[0].toString(36) + a[1].toString(36);
    } catch (e) {
      r = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    }
    return CONFIG.leadPrefix + '-' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' +
      (r + '000000').slice(0, 6).toUpperCase();
  }
  function buildPayload(form, id) {
    var p = { token: CONFIG.token, lead_id: id, form_id: form.id || '', form_page_url: pageUrl() };
    new FormData(form).forEach(function (value, name) {
      if (typeof value !== 'string') return;
      var m = name.match(/^contact\[(.+)\]$/);
      if (m) {
        var key = norm(m[1]);
        if (key === 'lead_id' || CONFIG.excludeFields.indexOf(key) > -1) return;
        key = ALIAS[key] || key;
        p[key] = p[key] ? p[key] + ', ' + value : value;
      } else if (name.indexOf('fpd_') === 0 && name !== 'fpd_lead_id') {
        p[name.slice(4)] = value;
      }
    });
    if (!p.service) p.service = trunc(document.title);
    return p;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!isContactForm(form)) return;
    try {
      ensureFields(form);
      fillFields(form, readState());
      var id = form.getAttribute('data-fpd-lead-id') || newLeadId();
      form.setAttribute('data-fpd-lead-id', id);
      field(form, 'fpd_lead_id').value = id;
      field(form, 'contact[Lead ID]').value = id;
      sSet('sessionStorage', CONFIG.pendingKey, JSON.stringify({ t: now(), p: buildPayload(form, id) }));
    } catch (err) { /* never block the form */ }
  }

  /* ---------- send only after Shopify confirms the submit ---------- */
  function send(payload) {
    if (!/^https:\/\/script\.google\.com\//.test(CONFIG.webhookUrl)) return;
    var body = JSON.stringify(payload);
    var beacon = function () {
      try { navigator.sendBeacon(CONFIG.webhookUrl, new Blob([body], { type: 'text/plain;charset=UTF-8' })); } catch (e) {}
    };
    try {
      fetch(CONFIG.webhookUrl, {
        method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body
      })['catch'](beacon);
    } catch (e) { beacon(); }
  }
  function flush() {
    var pending = parse(sGet('sessionStorage', CONFIG.pendingKey));
    if (!pending || !pending.p) return;
    if (now() - (pending.t || 0) > CONFIG.pendingTtlMs) { sDel('sessionStorage', CONFIG.pendingKey); return; }
    if (!CONFIG.successPattern.test(location.pathname + location.search)) return;
    sDel('sessionStorage', CONFIG.pendingKey);
    send(pending.p);
  }

  /* ---------- init ---------- */
  var state = capture();
  function initForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isContactForm(forms[i])) { ensureFields(forms[i]); fillFields(forms[i], state); }
    }
    flush();
  }
  document.addEventListener('submit', onSubmit, true); // capture phase: runs before hCaptcha/theme handlers
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initForms);
  else initForms();
  document.addEventListener('shopify:section:load', initForms);

  // QA helper: run fpdLeadAttribution.debug() in the browser console
  window.fpdLeadAttribution = {
    version: '1.0',
    debug: function () { return { stored: readState(), fields: attribution(readState()), pending: parse(sGet('sessionStorage', CONFIG.pendingKey)) }; }
  };
})();